@if (selectedTenant$ | async) {}
@if (canManageTenant$ | async) {}

<span raUiTooltip="{{ Disabled ? AllocateToolTip : null }}" [tooltipConfig]="AllocateTooltipConfig">
  @if (Status === 'Active' || TrialLinkStatus === 'redeemed') {
    <ra-ui-outlined-button label="Allocate" (click)="btnClickedHandler()" [disabled]="Disabled"></ra-ui-outlined-button>
  }
</span>
@if (TrialLinkStatus === TRIAL_LINK_STATUS.TRIALEXPIRED || Status === ENTITLEMENT_STATUS.COMPLETED) {
  <div class="status-icon">
    <i class="ra-icon-ide-md-color-unprovisioned"></i>
    <span>Expired</span>
  </div>
}
@if (Status === ENTITLEMENT_STATUS.CANCELLED) {
  <div class="cancelled-status">
    <span
      class="status-icon"
      [raUiTooltip]="'This entitlement has been cancelled by an administrator.'"
      [tooltipConfig]="tooltipConfig"
    >
      <i class="ra-icon-ide-md-color-unprovisioned"></i>
      Cancelled
    </span>
  </div>
}
